/* ================================================================================ */
/* Boost AI Search & Filter の商品カードに、テーマ固有の表示要素を後付けする         */
/*                                                                                  */
/* Boost のカードは React によるクライアント描画で、Liquid が介入できない。          */
/* かつ Boost の標準機能では以下を出せないため、描画後の DOM に差し込む。            */
/*                                                                                  */
/*   1. 状態ランク（商品タグ `状態ランク：X` から生成。テーマの .cart__rank 相当）    */
/*   2. お気に入りハート（Multilikes。Boost の wishlist 連携は Swish/Swym/Mst/       */
/*      Smart Wishlist/Growave のみで Multilikes は非対応のため自前で差し込む）      */
/*   3. サイズ（メタフィールド `custom.size-label`）                                 */
/*                                                                                  */
/* サイズだけは商品データの入手経路が違う。Boost がカードに埋める data-product には   */
/* metafields が含まれないが、Boost 自身が叩く filter API のレスポンスには入っている。*/
/* 詳しい経緯は fetchSizes() のコメントを参照。                                       */
/*                                                                                  */
/* Multilikes 側（assets/multilikes-product-favorite.js）が MutationObserver で      */
/* [data-multilikes-product-favorite] を監視しているので、ボタンの HTML を置くだけで  */
/* クリック処理・ログイン判定・状態同期はすべて Multilikes が引き受ける。            */
/*                                                                                  */
/* 商品データは Boost がカードの data-product 属性に JSON で持たせている。           */
/* ================================================================================ */

(function () {
  'use strict';

  var ITEM_SELECTOR = '.boost-sd__product-item';
  var INFO_SELECTOR = '.boost-sd__product-info';
  var LABEL_COLUMN_SELECTOR =
    '.boost-sd__product-image-column--in-top.boost-sd__product-image-column--left';
  var DONE_ATTR = 'data-rehello-enhanced';

  var COUNT_SELECTOR = '.boost-sd__product-count';
  var COUNT_DONE_ATTR = 'data-rehello-count';

  /* 価格フィルター。Boost は目盛りにも入力欄にも桁区切りの無い生の数値を出す */
  var PRICE_PIPS_SELECTOR = '.boost-sd__filter-option-range-slider .noUi-pips';
  var PRICE_PIPS_DONE_ATTR = 'data-rehello-pips';
  var PRICE_INPUT_SELECTOR = '.boost-sd__filter-option-range-slider-input';
  var PRICE_INPUT_BOUND_ATTR = 'data-rehello-price-input';

  /* SP の絞り込みボタン。ライブは「商品を絞り込み」＋ フィルターアイコン
     （globo.filter の SVG をそのまま使う）。Boost は「絞り込み」＋ 別のアイコン */
  var FILTER_TOGGLE_SELECTOR = '.boost-sd__filter-tree-toggle-button';
  var FILTER_TOGGLE_DONE_ATTR = 'data-rehello-filter-toggle';
  var FILTER_TOGGLE_TEXT = '商品を絞り込み';
  var FILTER_TOGGLE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1408" width="14" height="17" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M1024 1280h640v-128h-640v128zM640 768h1024V640H640v128zm640-512h384V128h-384v128zm512 832v256q0 26-19 45t-45 19H64q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19H64q-26 0-45-19T0 832V576q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19H64q-26 0-45-19T0 320V64q0-26 19-45T64 0h1664q26 0 45 19t19 45z"></path></svg>';

  /* NEW バッジの判定日数。
     ライブは「新着商品_トップページ」コレクション（handle: newitem）への所属で判定しており、
     そのコレクションの条件は「タグに直近3日分の日付（YYYY-MM-DD）を含む」。
     Boost の商品 JSON に collections が無いため、同じ日付タグを直接見て再現する。 */
  var NEW_DAYS = 3;

  var RANK_PREFIX = '状態ランク：';
  var RANK_LABELS = {
    S: '新品同様',
    A: '美品',
    B: '良品',
    C: '使用可能',
    D: '訳あり'
  };

  var FAVORITE_LABEL_OFF = 'お気に入り登録';
  var FAVORITE_LABEL_ON = 'お気に入り登録済み';

  var SIZE_NAMESPACE = 'custom';
  var SIZE_KEY = 'size-label';
  var SIZE_PREFIX = 'サイズ：';

  /* サイズの対応表（handle → 値）。
     値が null なのは「取得できたがメタフィールドを持っていない」商品。
     まだ取得できていない商品はキー自体が無い。 */
  var sizeMap = {};

  /* 同じ URL を二度叩かないための記録 */
  var fetchedUrls = {};

  function readSizeMetafield(metafields) {
    if (!Array.isArray(metafields)) return null;
    for (var i = 0; i < metafields.length; i++) {
      var field = metafields[i];
      if (!field) continue;
      if (field.namespace === SIZE_NAMESPACE && field.key === SIZE_KEY) {
        return typeof field.value === 'string' ? field.value : null;
      }
    }
    return null;
  }

  function captureSizes(data) {
    if (!data || !Array.isArray(data.products)) return false;
    var changed = false;
    for (var i = 0; i < data.products.length; i++) {
      var product = data.products[i];
      if (!product || !product.handle) continue;
      sizeMap[product.handle] = readSizeMetafield(product.metafields);
      changed = true;
    }
    return changed;
  }

  /* Boost が HTML を返させるために付けているパラメータ。
     これらを外すと同じ絞り込み条件のまま JSON（products 付き）で返ってくる */
  var HTML_MODE_PARAMS = [
    'widgetId',
    'templateId',
    'viewAs',
    'productImageWidth',
    'productPerRow',
    'widget_updated_at',
    'build_filter_tree',
    'insert_banners',
    'money_format',
    'money_format_with_currency',
    '_',
    't',
    'sid',
    'first_load',
    'device'
  ];

  /* Boost が直前に叩いた filter API の URL を流用して metafields を取りにいく。
     遠回りに見えるが、これが唯一の経路:
       - Boost がカードに埋める data-product に metafields は入っていない
       - Boost へのリクエストは傍受できない。window.fetch / XMLHttpRequest /
         Response.prototype.json をどれだけ差し替えても素通りする（他アプリによる
         汚染を避けるため iframe 由来のクリーンな fetch を使っている。実測で確認）
       - Boost 自身のリクエストは HTML を返すモードで、products を含まない

     URL を流用するので、並び順・ページ・絞り込み条件を自前で組み立てる必要がない。
     HTML モード用のパラメータだけ落として JSON で受け取る。 */
  function fetchSizes() {
    if (typeof performance === 'undefined' || !performance.getEntriesByType) return;
    if (typeof URL !== 'function') return;

    var entries = performance.getEntriesByType('resource');
    var latest = null;
    for (var i = entries.length - 1; i >= 0; i--) {
      var name = entries[i].name;
      /* コレクションは /filter、検索は /search。どちらも同じ形で products を返す */
      if (name.indexOf('/bc-sf-filter/filter') !== -1 || name.indexOf('/bc-sf-filter/search') !== -1) {
        latest = name;
        break;
      }
    }
    if (!latest) return;

    var url;
    try {
      url = new URL(latest);
    } catch (e) {
      return;
    }
    for (var k = 0; k < HTML_MODE_PARAMS.length; k++) {
      url.searchParams.delete(HTML_MODE_PARAMS[k]);
    }

    /* 毎回変わるタイムスタンプを落とした後の URL で重複を判定する */
    var key = url.toString();
    if (fetchedUrls[key]) return;
    fetchedUrls[key] = true;

    fetch(key)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (captureSizes(data)) scheduleScan();
      })
      .catch(function () {
        /* 取れなければサイズ行が出ないだけ。他の要素には影響させない */
      });
  }

  /* snippets/icon-favorite.liquid と同じパス。size=18 → height=15（19/23 比率） */
  var HEART_PATH =
    'M20.0011 2.09133C19.4848 1.58683 18.8717 1.18663 18.197 0.913583C17.5223 0.640537 16.7991 0.5 16.0688 0.5C15.3384 0.5 14.6152 0.640537 13.9405 0.913583C13.2658 1.18663 12.6528 1.58683 12.1365 2.09133L11.0649 3.13785L9.99342 2.09133C8.95051 1.07276 7.53602 0.500528 6.06112 0.500528C4.58622 0.500528 3.17173 1.07276 2.12881 2.09133C1.0859 3.1099 0.5 4.49139 0.5 5.93187C0.5 7.37235 1.0859 8.75383 2.12881 9.77241L3.20034 10.8189L11.0649 18.5L18.9296 10.8189L20.0011 9.77241C20.5176 9.26814 20.9274 8.66943 21.207 8.01045C21.4865 7.35148 21.6304 6.64517 21.6304 5.93187C21.6304 5.21857 21.4865 4.51226 21.207 3.85328C20.9274 3.19431 20.5176 2.59559 20.0011 2.09133Z';

  function heartSvg(filled) {
    return (
      '<svg class="icon icon-favorite" viewBox="0 0 23 19" width="18" height="15"' +
      ' fill="' + (filled ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1"' +
      ' stroke-linecap="round" stroke-linejoin="round" style="overflow: visible;"' +
      ' aria-hidden="true" focusable="false">' +
      '<path d="' + HEART_PATH + '" vector-effect="non-scaling-stroke"/></svg>'
    );
  }

  /* data-product の JSON を読む。Boost が属性を持たない場合もあるので必ず握りつぶす */
  function readProduct(item) {
    var raw = item.getAttribute('data-product');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  /* お気に入り登録に使うバリアント ID。テーマ側の
     product.selected_or_first_available_variant.id と同じ選び方にする。

     Boost の data-product は variantId をバリアント分割表示（splitProduct）の時しか
     埋めず、通常は空文字。variants は JSON 文字列（改行・空白入り）で入っているので
     パースして、在庫のある最初のバリアント → 無ければ先頭を採る。 */
  function readVariantId(product) {
    if (!product) return '';
    if (product.variantId) return String(product.variantId);

    var variants = product.variants;
    if (typeof variants === 'string') {
      try {
        variants = JSON.parse(variants);
      } catch (e) {
        return '';
      }
    }
    if (!Array.isArray(variants) || !variants.length) return '';

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v && v.available && v.id) return String(v.id);
    }
    return variants[0] && variants[0].id ? String(variants[0].id) : '';
  }

  /* タグ `状態ランク：C` → 「状態：C(使用可能)」。該当タグが無ければ null */
  function rankText(tags) {
    if (!Array.isArray(tags)) return null;
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i]);
      if (tag.indexOf(RANK_PREFIX) !== 0) continue;
      var rank = tag.slice(RANK_PREFIX.length).trim();
      var label = RANK_LABELS[rank];
      if (!label) continue;
      return '状態：' + rank + '(' + label + ')';
    }
    return null;
  }

  /* 状態ランクとサイズは1行ずつ密着して並ぶ（ライブ実測で行間0）。
     Boost の .boost-sd__product-info は flex-wrap: wrap で row-gap を持つため、
     直接置くと行間が空いてしまう。2行をまとめて1つの flex アイテムにする */
  function ensureMeta(info) {
    var meta = info.querySelector('.boost-sd__rehello-meta');
    if (meta) return meta;
    meta = document.createElement('div');
    meta.className = 'boost-sd__rehello-meta';
    info.insertBefore(meta, info.firstChild);
    return meta;
  }

  function buildRank(text) {
    var p = document.createElement('p');
    p.className = 'boost-sd__rehello-rank';
    p.textContent = text;
    return p;
  }

  /* サイズ行。ライブは値が無くても空行を出して高さを保っているので、それに合わせる
     （テーマ側 snippets/custom-card-product.liquid の `&nbsp;` と同じ扱い） */
  function buildSize(value) {
    var p = document.createElement('p');
    p.className = 'boost-sd__rehello-size';
    if (value === null || value === '') p.innerHTML = '&nbsp;';
    else p.textContent = SIZE_PREFIX + value;
    return p;
  }

  /* サイズは API のレスポンス待ちで後から届くので、enhance とは切り離して
     カード1枚ずつ何度でも試せるようにしてある */
  function applySize(item) {
    var info = item.querySelector(INFO_SELECTOR);
    if (!info || info.querySelector('.boost-sd__rehello-size')) return;

    var product = readProduct(item);
    var handle = product && product.handle;
    if (!handle || !(handle in sizeMap)) return;

    /* 状態ランクの下に置く。ランクが無い商品でもラッパーは作る */
    ensureMeta(info).appendChild(buildSize(sizeMap[handle]));
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* 直近 NEW_DAYS 日分の YYYY-MM-DD を作る（今日を含む） */
  function recentDates() {
    var out = [];
    var today = new Date();
    for (var i = 0; i < NEW_DAYS; i++) {
      var d = new Date(today.getFullYear(), today.getMonth(), today.getDate() - i);
      out.push(d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()));
    }
    return out;
  }

  function isNew(tags) {
    if (!Array.isArray(tags)) return false;
    var days = recentDates();
    for (var i = 0; i < tags.length; i++) {
      if (days.indexOf(String(tags[i]).trim()) !== -1) return true;
    }
    return false;
  }

  /* Boost のラベルと同じ構造で作る。見た目（角丸・余白）は Boost の CSS を継承し、
     色だけ boost-filter-custom.css 側でテーマのゴールドに寄せる */
  function buildNewLabel() {
    var wrap = document.createElement('div');
    wrap.className =
      'boost-sd__product-label boost-sd__product-label--text boost-sd__product-label--rectangle boost-sd__rehello-label--new';
    var outer = document.createElement('span');
    outer.className = 'boost-sd__product-label-text';
    var inner = document.createElement('span');
    inner.textContent = 'NEW';
    outer.appendChild(inner);
    wrap.appendChild(outer);
    return wrap;
  }

  function buildFavorite(productId, variantId) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'multilikes-card-favorite boost-sd__rehello-favorite';
    btn.setAttribute('data-multilikes-product-favorite', '');
    btn.setAttribute('data-product-id', productId);
    if (variantId) btn.setAttribute('data-variant-id', variantId);
    btn.setAttribute('data-label-off', FAVORITE_LABEL_OFF);
    btn.setAttribute('data-label-on', FAVORITE_LABEL_ON);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', FAVORITE_LABEL_OFF);
    btn.innerHTML =
      '<span class="multilikes-card-favorite__icon multilikes-card-favorite__icon--outline" aria-hidden="true">' +
      heartSvg(false) +
      '</span><span class="multilikes-card-favorite__icon multilikes-card-favorite__icon--filled" aria-hidden="true">' +
      heartSvg(true) +
      '</span>';
    return btn;
  }

  function enhance(item) {
    if (!item || item.getAttribute(DONE_ATTR) === '1') return;

    var productId = item.getAttribute('data-product-id') || item.id;
    if (!productId) return;

    /* 再描画で中身だけ差し替わる場合に備え、印は先に付ける */
    item.setAttribute(DONE_ATTR, '1');

    var product = readProduct(item);

    /* --- 状態ランク: 商品名の直前に置く --- */
    var info = item.querySelector(INFO_SELECTOR);
    if (info && !info.querySelector('.boost-sd__rehello-rank')) {
      var text = rankText(product && product.tags);
      if (text) {
        var meta = ensureMeta(info);
        meta.insertBefore(buildRank(text), meta.firstChild);
      }
    }

    /* --- NEW バッジ: 画像左上のラベル列へ。
       ライブは「売り切れ > SALE > NEW」の排他表示で、同時に2つは出さない。
       Boost が SALE・売り切れのラベルを描いている時は NEW を足さない
       （このセレクタは NEW 自身にも当たるので、二重付与の防止も兼ねる） --- */
    var labelColumn = item.querySelector(LABEL_COLUMN_SELECTOR);
    if (
      labelColumn &&
      !labelColumn.querySelector('.boost-sd__product-label') &&
      isNew(product && product.tags)
    ) {
      labelColumn.appendChild(buildNewLabel());
    }

    /* --- お気に入り: カード右上。Multilikes が後から拾ってバインドする。
       Multilikes は商品 ID とバリアント ID の組で登録するので、
       バリアント ID が取れないカードにはハートを出さない
       （出すと variant_id=undefined で登録され、お気に入りに壊れた項目が残る） --- */
    if (!item.querySelector('[data-multilikes-product-favorite]')) {
      var variantId = readVariantId(product);
      if (variantId) item.appendChild(buildFavorite(productId, variantId));
    }
  }

  function handle(item) {
    enhance(item);
    applySize(item);
  }

  /* 商品数の表示。
     ライブ（GLOBO）は `対象商品 11764 商品` で、**数字だけ一回り大きい**組みになっている
     （`.gf-summary::before` が「対象商品」、数字が `<b>` で 20px、単位が 14px）。
     Boost は同じ文言をテキスト1行で出しており、数字が独立していないので
     CSS では数字だけを大きくできない。文言はそのままに、数字だけ <b> で包み直す。
     見た目の値は boost-filter-custom.css 側で当てる。 */
  function applyProductCount(root) {
    var nodes = [];
    if (root.matches && root.matches(COUNT_SELECTOR)) nodes.push(root);
    if (root.querySelectorAll) {
      var found = root.querySelectorAll(COUNT_SELECTOR);
      for (var i = 0; i < found.length; i++) nodes.push(found[i]);
    }

    for (var k = 0; k < nodes.length; k++) {
      var el = nodes[k];
      /* 自分で書き換えた分がまた MutationObserver に拾われるので、印で二度目を止める */
      if (el.getAttribute(COUNT_DONE_ATTR) === '1') continue;

      var text = el.textContent;
      var matched = text.match(/[\d,]+/);
      if (!matched) continue;

      /* 前後の空白は落とす。ライブは「対象商品」の直後を 4px の padding で空けており、
         半角スペース（約6px）だと 2px 広い。空けは CSS 側の margin で作る */
      var before = text.slice(0, matched.index).replace(/^\s+/, '').replace(/\s+$/, '');
      var after = text.slice(matched.index + matched[0].length);

      el.setAttribute(COUNT_DONE_ATTR, '1');
      el.textContent = '';

      if (before) el.appendChild(document.createTextNode(before));
      var number = document.createElement('b');
      number.textContent = matched[0];
      el.appendChild(number);
      if (after) el.appendChild(document.createTextNode(after));
    }
  }

  /* SP の絞り込みボタンをライブの文言・アイコンに差し替える。
     どちらも Boost のテキスト／SVG なので CSS では変えられない。 */
  function applyFilterToggle(root) {
    var nodes = [];
    if (root.matches && root.matches(FILTER_TOGGLE_SELECTOR)) nodes.push(root);
    if (root.querySelectorAll) {
      var found = root.querySelectorAll(FILTER_TOGGLE_SELECTOR);
      for (var i = 0; i < found.length; i++) nodes.push(found[i]);
    }

    for (var k = 0; k < nodes.length; k++) {
      var btn = nodes[k];
      if (btn.getAttribute(FILTER_TOGGLE_DONE_ATTR) === '1') continue;

      var label = btn.querySelector('.boost-sd__filter-tree-toggle-button-text');
      var icon = btn.querySelector('.boost-sd__filter-tree-toggle-button-icon');
      if (!label && !icon) continue;

      btn.setAttribute(FILTER_TOGGLE_DONE_ATTR, '1');
      if (label) label.textContent = FILTER_TOGGLE_TEXT;
      if (icon) icon.innerHTML = FILTER_TOGGLE_ICON;
    }
  }

  function toYen(value) {
    var digits = String(value).replace(/[^\d]/g, '');
    if (!digits) return '';
    return '¥' + Number(digits).toLocaleString('ja-JP');
  }

  /* 価格フィルターの目盛り。CSS で両端の2点だけ残してあるので、
     残った値を「¥1,870」の形に整える。Boost が描くテキストなので JS でしか変えられない。 */
  function applyPricePips(root) {
    var nodes = [];
    if (root.matches && root.matches(PRICE_PIPS_SELECTOR)) nodes.push(root);
    if (root.querySelectorAll) {
      var found = root.querySelectorAll(PRICE_PIPS_SELECTOR);
      for (var i = 0; i < found.length; i++) nodes.push(found[i]);
    }

    for (var k = 0; k < nodes.length; k++) {
      var pips = nodes[k];
      if (pips.getAttribute(PRICE_PIPS_DONE_ATTR) === '1') continue;

      var values = pips.querySelectorAll('.noUi-value');
      if (!values.length) continue;

      /* 書き換えで MutationObserver がまた回るので、印を先に付ける */
      pips.setAttribute(PRICE_PIPS_DONE_ATTR, '1');

      for (var v = 0; v < values.length; v++) {
        var formatted = toYen(values[v].textContent);
        if (formatted) values[v].textContent = formatted;
      }
    }
  }

  /* Boost は入力欄を描いた直後に値を入れるので、DOM の追加を検知した時点では
     まだ空のことがある（SP のドロワーで顕著）。一度だけ遅らせて整え直す */
  var priceInputRetry = false;

  /* 価格の入力欄。表示は桁区切り付きにし、触っている間だけ数字だけに戻す。
     Boost は入力値を数値として読むので、確定時にカンマが混ざらないようにする。 */
  function applyPriceInputs(root) {
    var nodes = [];
    if (root.matches && root.matches(PRICE_INPUT_SELECTOR)) nodes.push(root);
    if (root.querySelectorAll) {
      var found = root.querySelectorAll(PRICE_INPUT_SELECTOR);
      for (var i = 0; i < found.length; i++) nodes.push(found[i]);
    }

    for (var k = 0; k < nodes.length; k++) {
      var input = nodes[k];

      if (input.getAttribute(PRICE_INPUT_BOUND_ATTR) !== '1') {
        input.setAttribute(PRICE_INPUT_BOUND_ATTR, '1');
        input.addEventListener('focus', function () {
          this.value = this.value.replace(/[^\d]/g, '');
        });
        input.addEventListener('blur', function () {
          var digits = this.value.replace(/[^\d]/g, '');
          if (digits) this.value = Number(digits).toLocaleString('ja-JP');
        });
      }

      /* フォーカス中は触らない（入力の邪魔になる） */
      if (document.activeElement === input) continue;
      var digits = input.value.replace(/[^\d]/g, '');
      if (!digits) continue;
      var display = Number(digits).toLocaleString('ja-JP');
      if (input.value !== display) input.value = display;
    }

    if (nodes.length && !priceInputRetry) {
      priceInputRetry = true;
      window.setTimeout(function () {
        priceInputRetry = false;
        applyPriceInputs(document.body);
      }, 400);
    }
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    applyProductCount(root);
    applyFilterToggle(root);
    applyPricePips(root);
    applyPriceInputs(root);
    if (root.matches && root.matches(ITEM_SELECTOR)) handle(root);
    var items = root.querySelectorAll ? root.querySelectorAll(ITEM_SELECTOR) : [];
    for (var i = 0; i < items.length; i++) handle(items[i]);
    /* Boost がリクエストを投げ終えた後に呼ばれるので、ここで URL を拾える */
    if (items.length) fetchSizes();
  }

  /* API のレスポンスが届いたら、描画済みのカードにもサイズを埋めにいく */
  var scanTimer = null;

  function scheduleScan() {
    if (scanTimer) return;
    scanTimer = window.setTimeout(function () {
      scanTimer = null;
      scan(document.body);
    }, 50);
  }

  function init() {
    scan(document.body);

    if (typeof MutationObserver === 'undefined') return;

    /* Boost はフィルター操作・ページ送りのたびにカードを差し替えるので監視し続ける */
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) scan(added[j]);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
